<form [formGroup]="form">
  <portal-modal-header [entry]="entry" (onClose)="dismiss()"></portal-modal-header>

  <portal-modal-body>
    <portal-error-alert [error]="error"></portal-error-alert>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-6 ps-0">
          <div class="form-group">
            <label class="form-label" for="firstName">{{ 'phoneBook.firstName' | portalTranslate }}</label>
            <input
              class="form-control"
              id="firstName"
              [portalAutofocus]="true"
              autocomplete="off"
              formControlName="firstName"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="firstName"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="lastName">{{ 'phoneBook.lastName' | portalTranslate }}</label>
            <input
              class="form-control"
              id="lastName"
              autocomplete="off"
              formControlName="lastName"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="lastName"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="company">{{ 'phoneBook.company' | portalTranslate }}</label>
            <input
              class="form-control"
              id="company"
              autocomplete="off"
              formControlName="company"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="company"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="department">{{ 'phoneBook.department' | portalTranslate }}</label>
            <input
              class="form-control"
              id="department"
              autocomplete="off"
              formControlName="department"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="department"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="jobTitle">{{ 'phoneBook.jobTitle' | portalTranslate }}</label>
            <input
              class="form-control"
              id="jobTitle"
              autocomplete="off"
              formControlName="jobTitle"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="jobTitle"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <!-- VIP Priority -->
            <label class="form-label" for="vipPriority">{{ 'acd.vip.priority' | portalTranslate }}</label>
            <ngx-slider id="vipPriority" [options]="sliderOptions" formControlName="vipPriority"></ngx-slider>
            <portal-form-validation-errors controlName="jobTitle"></portal-form-validation-errors>
          </div>
        </div>
        <div class="col-12 col-md-6 pe-0">
          <div class="form-group">
            <label class="form-label" for="mobilePhone">{{
              'phoneBook.mobilePhone' | portalTranslate
            }}</label>
            <input
              class="form-control"
              id="mobilePhone"
              autocomplete="off"
              formControlName="mobilePhone"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="mobilePhone"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="businessPhone">{{
              'phoneBook.businessPhone' | portalTranslate
            }}</label>
            <input
              class="form-control"
              id="businessPhone"
              autocomplete="off"
              formControlName="businessPhone"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="businessPhone"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="businessFax">{{
              'phoneBook.businessFax' | portalTranslate
            }}</label>
            <input
              class="form-control"
              id="businessFax"
              autocomplete="off"
              formControlName="businessFax"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="businessFax"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="homePhone">{{ 'phoneBook.homePhone' | portalTranslate }}</label>
            <input
              class="form-control"
              id="homePhone"
              autocomplete="off"
              formControlName="homePhone"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="homePhone"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="email">{{ 'phoneBook.email' | portalTranslate }}</label>
            <input
              class="form-control"
              id="email"
              autocomplete="off"
              formControlName="email"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="email"></portal-form-validation-errors>
          </div>
          <div class="form-group">
            <label class="form-label" for="email2">{{ 'phoneBook.email2' | portalTranslate }}</label>
            <input
              class="form-control"
              id="email2"
              autocomplete="off"
              formControlName="email2"
              portalInputValidityState
              type="text"
            />
            <portal-form-validation-errors controlName="email2"></portal-form-validation-errors>
          </div>
        </div>
        <div class="col-12 px-0">
          <div class="form-group">
            <label class="form-label" for="note">{{ 'phoneBook.note' | portalTranslate }}</label>
            <textarea
              class="form-control"
              id="note"
              formControlName="note"
              name="note"
              portalInputValidityState
            ></textarea>
            <portal-form-validation-errors controlName="note"></portal-form-validation-errors>
          </div>
          <div>
            <div
              #accordionContactGroups="ngbAccordion"
              [closeOthers]="false"
              [destroyOnHide]="false"
              ngbAccordion
            >
              <!-- Contact Groups -->
              <div
                class="card"
                [collapsed]="false"
                [id]="'contactGroups'"
                [ngbAccordionItem]="'contactGroups'"
              >
                <!-- Header -->
                <div class="card-header" ngbAccordionHeader>
                  <div class="d-flex g-cursor-pointer w-100" ngbAccordionToggle>
                    <span>{{ 'acd.cc.phonebook.group.assignment' | translate }}</span>

                    <span class="btn btn--portal-link ms-auto">
                      <i
                        class="far"
                        [class]="{
                          'fa-angle-down': accordionContactGroups.isExpanded('contactGroups') === false,
                          'fa-angle-left': accordionContactGroups.isExpanded('contactGroups') === true,
                        }"
                      ></i>
                    </span>
                  </div>
                </div>

                <!-- Content -->
                <div ngbAccordionCollapse="">
                  <div ngbAccordionBody="">
                    <ng-template>
                      <ng-container>
                        <portal-contact-group-select
                          [contactGroups]="contactGroups"
                          formControlName="contactGroups"
                        ></portal-contact-group-select>
                      </ng-container>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </portal-modal-body>

  <portal-modal-footer
    [entry]="entry"
    [form]="form"
    [saving]="saving"
    (onCancel)="dismiss()"
    (onSave)="submit()"
  ></portal-modal-footer>
  <!-- [state$]="updateCallCenterContact$" -->
</form>
